export default __webpack_public_path__ + "static/media/login-bg-15.b9a64989.jpg";